import { Host, Component, h, Prop, Watch, Element } from '@stencil/core';

import { ClassMap } from 'src/utils/interfaces';

@Component({
  tag: 'fuel-grid-container',
  styleUrl: 'grid-container.scss',
  scoped: true,
})
export class FuelGridContainer {
  @Element() host: HTMLFuelGridContainerElement;

  /**
   * GridContainer Props
   */

  /** Applies a fixed max-width to the grid container */
  @Prop() fixed: boolean;
  /**
   * A number that defines the container's top margin
   * in pixels, without passing the 'px' unit.
   */
  @Prop() spacingTop: number = 0;
  /**
   * A number that defines the container's bottom margin
   * in pixels, without passing the 'px' unit.
   */
  @Prop() spacingBottom: number = 0;
  /**
   * A number that defines the container's horizontal gap between lines
   * in pixels, without passing the 'px' unit.
   */
  @Prop() gapRow: number = 40;

  componentDidLoad() {
    this.setSpacing();
  }

  @Watch('spacingTop')
  @Watch('spacingBottom')
  watchPropHandler() {
    this.setSpacing();
  }

  setSpacing() {
    this.host.style.marginTop = `${this.spacingTop}px`;
    this.host.style.marginBottom = `${this.spacingBottom}px`;
    this.host.style.rowGap = `${this.gapRow}px`;
  }

  getClassMap(): ClassMap {
    return {
      'grid-container': true,
      'grid-container--fixed': this.fixed,
    };
  }

  render() {
    return (
      <Host class={this.getClassMap()}>
        <slot></slot>
      </Host>
    );
  }
}
